import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'chevron-compact-right', 'ChevronCompactRight', [["path",{"d":"M11 4l3 8l-3 8"}]]);